<template>
    <div class="form-input-wrapper">
    <label class="form-label" :for="id">
      <span>{{ label }}</span>
    </label>
    <div class="izvod-upload-row">
        <!-- <div class="izvod-button izvod-choose-from-desktop">odaberi s računala</div> -->
        <label class="izvod-button izvod-choose-from-desktop">
            {{ $t('forms.person.prav_pers.btn') }}

            <input
                @change="onChange"
                type="file"
                id="assetsFieldHandle"
                ref="file"
                style="display:none;"
                accept="application/pdf"
            />
        </label>
        <div @click="!loading_from_api ? askSudReg(oib) : ''" class="izvod-button api-button">API</div>
        <div class="sud-reg-loader-wrapper" v-if="loading_from_api">
            <svg class="update-event-spin spinner-ulazna" id="add-to-ulazna"
                viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
            </svg>
            <span>{{ $t('forms.person.prav_pers.searching') }}</span>
        </div>
        <div v-else>
            <div v-if="temp_privici.length > 0" class="izvod-file-wrapper">
                <div @click="previewFile(temp_privici[0])" class="izvod-file">
                    <img src="@/assets/img/pdf_icon.svg"/>
                    <span>{{temp_privici[0].name}}</span>
                </div>
                <div @click="deleteIzvod()" class="add-napomena add-button remove-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                    </svg>
                </div>
            </div>
            <div v-else-if="file != undefined && file != null" class="izvod-file-wrapper">
                <div @click="getFileAndPreview(file)" class="izvod-file">
                    <img src="@/assets/img/pdf_icon.svg"/>
                    <span>{{file.name}}</span>
                </div>
                <div @click="deleteIzvod()" class="add-napomena add-button remove-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <v-dialog v-model="missing_oib_dialog" width="564px">
        <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
            {{missing_oib_text}}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="missing_oib_dialog = false;">{{ $t("repetitive.okay") }}</div>
        </div>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import auth from "@/services/auth";

export default {
    props:['label','id','file', 'oib'],
    data(){
        return{
            temp_privici:[],
            missing_oib_dialog:false,
            missing_oib_text:'',
            deleted_privici:null,
            loading_from_api:false,
        }
    },
    methods:{
        onChange(){
            const add_files = [...this.$refs.file.files];
            const final_files = add_files.filter((file)=>file.size < 57671680);
            const num_odbacenih = add_files.length - final_files.length;
            if (num_odbacenih != 0) {
                this.snackbar = true;
                this.snackText =this.$t("snackbars.sharepoint_size", { length: num_odbacenih });
            }
            this.deleteIzvod();
            this.temp_privici = final_files;
        },
        deleteIzvod(){
            console.log("LOG")
            if (this.file != null) {
                this.deleted_privici={
                    id:this.file.id,
                    name:this.file.name,
                }
            }
            this.temp_privici = [];
            this.$emit('clearActiveFile');
        },
        async getFileAndPreview(file){
            this.accessToken = this.$store.state.aToken 
            await osoba.getIzvod(this.accessToken, file.id).then((resp) => {
                //pripremanje download linka
                var link = document.createElement("a");
                link.setAttribute("href", resp.data.webUrl);
                link.setAttribute("target", "_blank");
                link.setAttribute("download", file.name);
                link.click();
            })
        },
        previewFile(file){
            var data = window.URL.createObjectURL(file);
            var link = document.createElement("a");
            link.href = data;
            link.download = file.name;
            link.click();
        },
        async askSudReg(){
            if(this.oib.value.length == 0){
                this.missing_oib_text=this.$t("forms.person.prav_pers.search_err")
                this.missing_oib_dialog=true;
            }
            else{
                this.loading_from_api=true;
                //zovi back nek pita sudski reg API
                await osoba.sudRegAPICall(this.oib.value.trim()).then((resp)=>{
                    console.log(resp);
                    var newBlob = new Blob([resp.data], {
                        type: "application/pdf",
                    });
                    newBlob.name = `sud_reg_izvod_${this.oib.value}.pdf`;
                    newBlob.lastModified = new Date();
                    const myFile = new File([newBlob], `sud_reg_izvod_${this.oib.value}.pdf`, {
                        type: newBlob.type,
                    });
                    this.deleteIzvod();
                    this.temp_privici = [myFile];
                })
                .catch((err)=>{
                    if (err.response.status == 404) {
                        this.missing_oib_text=`${this.$t("forms.person.prav_pers.not_found")} ${this.oib.value}`;
                        this.missing_oib_dialog=true;
                    }
                })
                .finally(()=>{
                    this.loading_from_api=false;
                })
            }
        } 
    },
    created(){

    }
}
</script>